import React from 'react';
import { Row, Col, Divider, List, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { MailFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Paragraph, Text } = Typography;

const FooterCom: React.FC = () => {
  const { t } = useTranslation('components');

  const footerStyle: React.CSSProperties = {
    textAlign: 'center',
    backgroundColor: '#282828',
    color: '#bfbfbf',
    padding: '24px 0',
  };

  const footerDivider: React.CSSProperties = {
    borderColor: '#bfbfbf',
    color: '#bfbfbf',
    fontSize: '14px',
    margin: '12px 0',
  };

  const copyrightStyle: React.CSSProperties = {
    textAlign: 'center',
    backgroundColor: '#000000',
    color: '#8c8c8c',
    fontSize: '12px',
    padding: '12px 0',
  };

  const itemStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 0',
    border: 'none',
  };

  const itemLinkStyle: React.CSSProperties = {
    color: '#bfbfbf',
    fontSize: '13px',
  };

  const commonColProps = {
    xs: 12,
    sm: 8,
    md: 4,
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <Row justify="center" style={footerStyle} gutter={[0, 16]}>
        <Col {...commonColProps}>
          <List split={false}>
            <Divider style={footerDivider} plain>
              {t('footer.sections.products')}
            </Divider>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/products/d10" target="_blank" rel="noopener noreferrer">
                {t('footer.products.d10')}
              </a>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/products/d20" target="_blank" rel="noopener noreferrer">
                {t('footer.products.d20')}
              </a>
            </List.Item>
          </List>
        </Col>

        <Col {...commonColProps}>
          <List split={false}>
            <Divider style={footerDivider} plain>
              {t('footer.sections.company')}
            </Divider>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/info#aboutus" target="_blank" rel="noopener noreferrer">
                {t('footer.company.about')}
              </a>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/info#vision" target="_blank" rel="noopener noreferrer">
                {t('footer.company.vision')}
              </a>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/info#contact" target="_blank" rel="noopener noreferrer">
                {t('footer.company.contact')}
              </a>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/cs" target="_blank" rel="noopener noreferrer">
                {t('footer.company.compliance')}
              </a>
            </List.Item>
          </List>
        </Col>

        <Col {...commonColProps}>
          <List split={false}>
            <Divider style={footerDivider} plain>
              {t('footer.sections.news')}
            </Divider>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/news" target="_blank" rel="noopener noreferrer">
                {t('footer.news.companyNews')}
              </a>
            </List.Item>
          </List>
        </Col>

        <Col {...commonColProps}>
          <List split={false}>
            <Divider style={footerDivider} plain>
              {t('footer.sections.joinUs')}
            </Divider>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://www.enrigin.com.cn/joinus" target="_blank" rel="noopener noreferrer">
                {t('footer.joinUs.recruitment')}
              </a>
            </List.Item>
          </List>
        </Col>

        <Col {...commonColProps}>
          <List split={false}>
            <Divider style={footerDivider} plain>
              {t('footer.sections.support')}
            </Divider>
            <List.Item style={itemStyle}>
              <Link style={itemLinkStyle} to="/support/downloads">
                {t('footer.support.docs')}
              </Link>
            </List.Item>
            <List.Item style={itemStyle}>
              <Link style={itemLinkStyle} to="/support/downloads">
                {t('footer.support.downloads')}
              </Link>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://play.enrigin.com.cn" target="_blank" rel="noopener noreferrer">
                {t('footer.support.playground')}
              </a>
            </List.Item>
            <List.Item style={itemStyle}>
              <a style={itemLinkStyle} href="https://ticket.enrigin.com.cn" target="_blank" rel="noopener noreferrer">
                {t('footer.support.tickets')}
              </a>
            </List.Item>
          </List>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <Divider style={footerDivider} plain>
            {t('footer.sections.contactUs')}
          </Divider>
          <Paragraph style={{ marginTop: '8px', marginBottom: '12px', whiteSpace: 'pre-wrap', color: '#bfbfbf' }}>
            <MailFilled style={{ color: 'white', marginRight: '4px' }} />
            <a href="mailto:info@enrigin.com.cn" style={{ color: '#bfbfbf' }}>
              info@enrigin.com.cn
            </a>
          </Paragraph>
          <div
            style={{
              position: 'relative',
              width: '100px',
              aspectRatio: '1/1',
              margin: '0 auto',
            }}
          >
            <img
              src="/QRcode.jpg"
              alt="QR code"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
        </Col>
      </Row>

      <Row justify="center" style={copyrightStyle}>
        <Col xs={22} md={24}>
          <Text style={{ ...copyrightStyle, display: 'block', marginBottom: 4 }}>
            {t('footer.copyright', { year: currentYear })}
          </Text>

          <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px', lineHeight: '20px' }}>
            <Text style={{ color: '#8c8c8c', fontSize: '12px' }}>{t('footer.icp.label')}</Text>
            <a
              style={{ color: '#8c8c8c', fontSize: '12px' }}
              href="http://beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
            >
              京ICP备2024068290号-1
            </a>

            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              <div
                style={{
                  display: 'inline-block',
                  position: 'relative',
                  width: 16,
                  height: 16,
                  marginRight: '4px',
                }}
              >
                <img
                  src="/NISM.png"
                  alt="NISM"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>
              <a
                style={{ color: '#8c8c8c', fontSize: '12px' }}
                href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802044445"
                target="_blank"
                rel="noopener noreferrer"
              >
                京公网安备11010802044445
              </a>
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FooterCom;
